import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  Box,
  TextField,
  FormControl,
  Typography,
  Switch,
  FormControlLabel,
  MenuItem,
  Select,
  InputLabel,
  Button,
  SelectChangeEvent,
  Stack,
  Checkbox
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { SQLTool } from '../../../Shared-ui/Types/Tool';
import { NotSelected } from '../../../Constant/Setting';
import { isOnlyAlphabets, isOnlyAlphabetsNumbers } from '../../../Shared-ui/utils/Common/Common';
import { StartLoading, StopLoading } from '../../../Shared-ui/Store/LoadingReducer/LoaderActions';
import { TOOLKIT, TOOLS } from '../../../Services/Endpoint';
import BaseInstance from '../../../Services/AxiosInstance/BaseInstance';
import { ShowError } from '../../../Shared-ui/Store/MessageReducer/MsgActions';
import { ToolsKitTypeEnum } from '../../../Shared-ui/Enum/ToolsEnum';

interface MycomponentProps {
  handleClose: () => void
  tool: SQLTool | null
}

const dialectOptions = [
  'PostgreSQL',
  'MySQL',
  'SQLite',
  'Oracle',
  'Microsoft SQL Server'
];

const SQLTools: React.FC<MycomponentProps> = (props) => {



  const toolErrIntial = {
    name: { error: "", value: false },
    description: { error: "", value: false },
    db_url: { error: "", value: false },
    dialect: { error: "", value: false },

  }
  const toolInitial: SQLTool = {
    name: '',
    description: '',
    type: 'toolkit',
    is_active: true,
    config: {
      toolkit_type: ToolsKitTypeEnum.Sql,
      db_url: '',
      dialect: NotSelected,
      describe_table: true,
      list_tables: true,
      run_sql_query: true,
      schema: "public"
    },

  }
  const [tools, setTools] = useState<SQLTool>(toolInitial);
  const [toolsErr, setToolsErr] = useState(toolErrIntial);
  const [isEditing, setIsEditing] = useState(false)
  const [disableSubmit, setDisableSubmit] = useState<boolean>(true)
  const dispatch = useDispatch()

  useEffect(() => {
    // Check if all required agent fields are filled (returns true/false)
    const requiredFieldsFilled =
      !!tools.name.trim() &&
      !!tools.description.trim() &&
      !!tools.config.db_url.trim()&&  
      tools.config.dialect !== NotSelected

    setDisableSubmit(!requiredFieldsFilled);
  }, [tools]);

  useEffect(() => {
    if (props.tool) {
      setTools(props.tool)
      setIsEditing(true)
    }
  }, [])

  const handleCreateTool = async () => {
    if (!validateTool()) return
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.post(TOOLKIT, tools).then(
        (res) => res?.data
      );
      handleCancel()
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail || err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }


  }


  const handleupdateTool = async () => {
    if (!validateTool()) return
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.put(`${TOOLS}/${tools.id}`, tools).then(
        (res) => res?.data
      );
      handleCancel()
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail || err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }


  }

  const validateTool = () => {
    var error = 0
    const setError = (field: string, condition: boolean, message: string) => {
      if (condition) {
        setToolsErr(prev => ({
          ...prev,
          [field]: { error: message, value: true }
        }));
        error += 1;
      } else {
        setToolsErr(prev => ({
          ...prev,
          [field]: { error: "", value: false }
        }));
      }
    };

    setError("name", (!tools.name.trim() || !isOnlyAlphabetsNumbers(tools.name.trim())), "Please enter the name A-z");
    setError("description", !tools.description.trim(), "Please enter the description A-z")
    setError("db_url", !tools.config.db_url.trim(), "Please enter the db url")
    setError("dialect", tools.config.dialect === NotSelected, "Please enter the db type")

    return error > 0 ? false : true
  }

  const handleCancel = () => {
    setTools(toolInitial)
    props.handleClose()
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target
    setTools(preVal => ({ ...preVal, [name]: value }))
  };
  const handleChangeConfig = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent) => {

    const { name, value } = event.target
    setTools(preVal => ({ ...preVal, config: { ...preVal.config, [name]: value } }))
  };

  const handleChangeConfigClick = (event: any) => {
    const name = event.target.name
    const checked = event.target.checked
    setTools(preVal => ({ ...preVal, config: { ...preVal.config, [name]: checked } }))
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FormControl fullWidth error={toolsErr.name.value}>
        <TextField
          label="Tool Name"
          value={tools.name}
          name='name'
          onChange={handleChange}
          variant="outlined"
          error={toolsErr.name.value}
          helperText={toolsErr.name.error}
        />
      </FormControl>

      <FormControl fullWidth error={toolsErr.description.value}>
        <TextField
          label="Description"
          name='description'
          value={tools.description}
          onChange={handleChange}
          variant="outlined"
          multiline
          rows={2}
          error={toolsErr.description.value}
          helperText={toolsErr.description.error}
        />
      </FormControl>
      <Typography variant="body1" gutterBottom>
        Configuration of SQL
      </Typography>
      <FormControl fullWidth error={toolsErr.db_url.value}>
        <TextField
          label="Database URL"
          value={tools.config.db_url}
          name='db_url'
          onChange={handleChangeConfig}
          variant="outlined"
          error={toolsErr.db_url.value}
          helperText={toolsErr.db_url.error}
        />
      </FormControl>

      <FormControl fullWidth error={toolsErr.dialect.value}>
        <InputLabel id="dialect-select-label">SQL Dialect</InputLabel>
        <Select
          labelId="dialect-select-label"
          name='dialect'
          value={tools.config.dialect || NotSelected}
          label="SQL Dialect"
          error={toolsErr.dialect.value}
          onChange={handleChangeConfig}
        >
          <MenuItem key={9999} value={NotSelected}> Select DB type</MenuItem>
          {dialectOptions.map((sqlItem, index) => (
            <MenuItem key={index} value={sqlItem}>
              {sqlItem}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Stack spacing={2}>
        {/* Row 1 */}
        <Stack
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2,
          }}
        >
          <FormControlLabel control={<Checkbox onClick={handleChangeConfigClick} name='run_sql_query' checked={tools.config.run_sql_query} />} label="Run sqlquery" />
          <FormControlLabel control={<Checkbox name='describe_table' onClick={handleChangeConfigClick} checked={tools.config.describe_table} />} label="Describe table" />
          <FormControlLabel control={<Checkbox name='list_tables' onClick={handleChangeConfigClick} checked={tools.config.list_tables} />} label="List tables" />
        </Stack>
      </Stack>
      <FormControlLabel
        control={
          <Switch
            checked={tools.is_active}
            name='is_active'
            onChange={(e) => setTools(preVal => ({ ...preVal, [e.target.name]: e.target.checked }))}
          />
        }
        label="Active"
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
          mb: 3
        }}
      >
        <Button
          variant="outlined"
          size="large"
          sx={{ textTransform: "capitalize" }}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disableElevation
          disabled={disableSubmit}
          size="large"
          sx={{ textTransform: "capitalize" }}
          onClick={() => isEditing ? handleupdateTool() : handleCreateTool()}
        >
          {isEditing ? "Update" : "Create"}
        </Button>
      </Box>
    </Box>
  );
};

export default SQLTools;